import { AutomationRuleFilterInterface } from 'modules/automation-rules/types/automation-rule-filter-interface'

export const getActionFilterQuery = (filter: AutomationRuleFilterInterface) =>
  `${filter.action ? `&filter[action][type]=${filter.action}` : ''}${
    filter.actionCampaignId ? `&filter[action][campaignId]=${filter.actionCampaignId}` : ''
  }${filter.actionTagId ? `&filter[action][tagId]=${filter.actionTagId}` : ''}${
    filter.actionMailingId ? `&filter[action][emailId]=${filter.actionMailingId}` : ''
  }${
    filter.actionSpecificMailingId
      ? `&filter[action][emailId]=${filter.actionSpecificMailingId}`
      : ''
  }${
    filter.actionSpecificMailingId
      ? `&filter[action][specificEmailId]=${filter.actionSpecificMailingId}`
      : ''
  }${filter.actionCourseId ? `&filter[action][courseId]=${filter.actionCourseId}` : ''}${
    filter.locale ? `&filter[action][locale]=${filter.locale}` : ''
  }${
    filter.actionCourseBundleId
      ? `&filter[action][courseBundleId]=${filter.actionCourseBundleId}`
      : ''
  }${filter.locale ? `&filter[action][locale]=${filter.locale}` : ''}${
    filter.webhookUrl ? `&filter[action][webhookUrl]=${encodeURIComponent(filter.webhookUrl)}` : ''
  }${filter.actionCommunityId ? `&filter[action][communityId]=${filter.actionCommunityId}` : ''}${
    filter.pipelineStageId ? `&filter[action][pipelineStageId]=${filter.pipelineStageId}` : ''
  }${filter.pipelineId ? `&filter[action][pipelineId]=${filter.pipelineId}` : ''}${
    filter.actionSmsTemplateId ? `&filter[action][smsTemplateId]=${filter.actionSmsTemplateId}` : ''
  }`
